import { useTranslation } from 'react-i18next'
import SectionCard from '../shared/SectionCard'
import './style.css'
import TextArea from '@/components/formFields/TextArea'
import InputField from '@/components/formFields/InputField'

const PaymentTerms = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    return (
        <SectionCard title={t("payment-terms-header")}
            icon="streamline-plump:payment-recieve-7-remix"
            className="edit-refund-policy"
        >
            <div className="row col-lg-12">
                <InputField
                    isLoading={false}
                    type="number"
                    min={"1"}
                    className="col-lg-6"
                    label={t("paymentTermsAmount")}
                    formHandler={formHandler}
                    name={"paymentTermsAmount"}
                    defaultValue={providerInfo?.partialPaymentPercentage}
                />
            </div>
            <div className="row col-lg-12">
                <TextArea
                    className="col-lg-6"
                    formHandler={formHandler}
                    value={formHandler?.formValues?.paymentTerms}
                    name="payment-terms"
                    setValue={(value) => formHandler.handleFormValues('paymentTerms', value)}
                    label={t("payment-terms")}
                    placeholder={t("enter-payment-terms")}
                    defaultValue={providerInfo?.paymentTerms || ''}
                />
                <TextArea
                    className="col-lg-6"
                    lang="En"
                    formHandler={formHandler}
                    value={formHandler?.formValues?.paymentTermsEN}
                    name="payment-termsEN"
                    setValue={(value) => formHandler.handleFormValues('paymentTermsEN', value)}
                    label={t("payment-termsEN")}
                    placeholder={t("enter-payment-termsEN")}
                    defaultValue={providerInfo?.paymentTermsEN || ''}
                />
            </div>
        </SectionCard>
    )
}

export default PaymentTerms

